<button [type]="type" [attr.form]="form" mat-flat-button [disabled]="disabled" [class]="classes">
    <div>
      {{ label }}
      <mat-spinner *ngIf="loading" class="mm-text-white" diameter="20"></mat-spinner>
    </div>
</button>